import LangEnum from '../../../../../../lang/LangEnum';
import { formatDate } from '../../../../../../utils/dates';
import { getAvailabilityLangEnum } from '../../../../../products/ProductAvailabilityRenderer';
import { AvailabilityEnum } from '../../../../../products/ProductTypes';
import { CatalogNavigationDeliveryWindow } from '../../../../catalog.types';
import { CatalogDeliveryWindowLabel } from './catalogDetailsPanel.types';

const CATALOG_DETAILS_DATE_FORMAT = 'dd/MM/yyyy HH:mm';
export const CATALOG_DETAILS_EMPTY_VALUE = '-';

export const formatCatalogDateTime = (date?: Date | string | null): string => {
  if (!date) {
    return '';
  }

  return formatDate(date, CATALOG_DETAILS_DATE_FORMAT);
};

export const getDeliveryWindowLabels = (
  windows?: CatalogNavigationDeliveryWindow[],
): CatalogDeliveryWindowLabel[] =>
  (windows ?? [])
    .map((window) => ({ code: window.code ?? window.id, label: window.name ?? window.code }))
    .filter((window): window is CatalogDeliveryWindowLabel => Boolean(window.label));

export const getAvailabilityLabels = (
  availabilities: AvailabilityEnum[] | undefined,
  translate: (key: LangEnum) => string,
): string[] =>
  (availabilities ?? [])
    .filter((availability) => availability !== AvailabilityEnum.EMPTY)
    .map((availability) => translate(getAvailabilityLangEnum(false)[availability]));
